
import Icon from '../../common/Icon'

export default {
  name: 'SigninHeader',
  components: { Icon },
  props: {
    title: {
      type: String,
      default: 'Sign in'
    },
    navLinks: {
      type: Array,
      default: () => [
        { route: '/account/signin', name: 'Sign In', },
        { route: '/account/signup', name: 'Sign Up', },
      ]
    },
    helper: {
      type: String,
      default: null,
    },
    icon: Object,
  }
}
